enum ADAFeatureEnum {
  None = "None",
  Parking = "Parking",
  ExteriorBuilding = "Exterior_Building",
  InteriorBuilding = "Interior_Building",
  WaitingOrReception = "Waiting_Or_Reception",
  Restroom = "Restroom",
  ExamRoom = "Exam_Room",
  TDD = "TDD",
  BrailleSignage = "Braille_Signage",
  ExamTable = "Exam_Table",
  Lifts = "Lifts",
  MammographyEquipment = "Mammography_Equipment",
  RadiologicEquipment = "Radiologic_Equipment",
  StretchersAndGurneys = "Stretchers_And_Gurneys",
  WheelchairWeightScale = "Wheelchair_Weight_Scale",

}

export { ADAFeatureEnum };
